module.exports = __webpack_public_path__ + "images/kihnu/routes/LAA-PII-LAA.png";